"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MfaTelechargement = exports.separateur = exports.tailleMaximum = exports.kilo_octet = exports.max_mega_octet = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactBootstrap = require("react-bootstrap");

var _core = require("@material-ui/core");

var _MfaDialogue = require("./MfaDialogue");

var _utilitaires = require("../utils/utilitaires");

var _propTypes = _interopRequireDefault(require("prop-types"));

require("../css/mfa-telechargement.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var max_mega_octet = 10;
exports.max_mega_octet = max_mega_octet;
var kilo_octet = 1024;
exports.kilo_octet = kilo_octet;
var tailleMaximum = kilo_octet * kilo_octet * max_mega_octet;
exports.tailleMaximum = tailleMaximum;
var separateur = ',';
exports.separateur = separateur;

var MfaTelechargement = /*#__PURE__*/function (_Component) {
  _inherits(MfaTelechargement, _Component);

  var _super = _createSuper(MfaTelechargement);

  function MfaTelechargement(props) {
    var _this;

    _classCallCheck(this, MfaTelechargement);

    _this = _super.call(this, props);
    _this.state = {
      informations: null,
      desactiverBoutonSortir: true,
      typeDocument: '',
      etiquetteDocument: '',
      fichier: '',
      erreur: null,
      erreur2: null,
      desactiverRecherche: false,
      extentions: []
    };
    _this.surSortie = _this.surSortie.bind(_assertThisInitialized(_this));
    _this.surErreurFichier = _this.surErreurFichier.bind(_assertThisInitialized(_this));
    _this.surAnnulation = _this.surAnnulation.bind(_assertThisInitialized(_this));
    _this.surReceptionInformations = _this.surReceptionInformations.bind(_assertThisInitialized(_this));
    _this.surDesactiverConfimation = _this.surDesactiverConfimation.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(MfaTelechargement, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.reinitialiser();
    }
  }, {
    key: "reinitialiser",
    value: function reinitialiser() {
      var desactiver = Array.isArray(this.props.typeDocuments);
      var valeur = '';
      var etiquette = '';
      var uneErreur = '';

      if (desactiver && this.props.typeDocuments.length > 0) {
        desactiver = !(0, _utilitaires.nestPasNulOuVide)(this.props.typeDocuments[0].valeur);

        if ((0, _utilitaires.nestPasNulOuVide)(this.props.typeDocuments[0].valeur)) {
          valeur = this.props.typeDocuments[0].valeur;
          etiquette = this.props.typeDocuments[0].etiquette;
        }
      }

      var extentionsDocuments = [];
      var extentionExiste = (0, _utilitaires.estDefini)(this.props.typeDocumentsExtentions);

      if (extentionExiste) {
        extentionsDocuments = String(this.props.typeDocumentsExtentions).split(separateur);
        extentionExiste = extentionsDocuments.length > 0;
      }

      if (!extentionExiste) {
        desactiver = true;
        uneErreur = "Veuillez préciser au moins un type d'extention de fichier à télécharger.";
      }

      if ((0, _utilitaires.estDefini)(this.props.tailleMaximale)) {
        var taille = kilo_octet * kilo_octet * this.props.tailleMaximale;
        taille = taille > tailleMaximum ? taille : tailleMaximum;
        this.setState({
          maxTaille: taille,
          desactiverRecherche: desactiver,
          extentions: extentionsDocuments,
          erreur: uneErreur,
          erreur2: null,
          typeDocument: valeur,
          etiquetteDocument: etiquette,
          fichier: ''
        });
      } else {
        this.setState({
          maxTaille: tailleMaximum,
          desactiverRecherche: desactiver,
          extentions: extentionsDocuments,
          erreur: uneErreur,
          erreur2: null,
          typeDocument: valeur,
          etiquetteDocument: etiquette,
          fichier: ''
        });
      }

      if (!(0, _utilitaires.nestPasNulOuVide)(uneErreur)) {
        this.surErreurFichier({
          erreur: uneErreur
        });
      }
    }
  }, {
    key: "surDesactiverConfimation",
    value: function surDesactiverConfimation() {
      this.setState({
        desactiverBoutonSortir: true
      });
    }
  }, {
    key: "surErreurFichier",
    value: function surErreurFichier(erreur) {
      this.surDesactiverConfimation();
    }
  }, {
    key: "surReceptionInformations",
    value: function surReceptionInformations(informations) {
      this.setState({
        desactiverBoutonSortir: false,
        informations: informations
      });
    }
  }, {
    key: "surSortie",
    value: function surSortie() {
      if ((0, _utilitaires.estDefini)(this.props.surReceptionInformations)) {
        this.props.surReceptionInformations(this.state.informations);
      }

      this.reinitialiser();
    }
  }, {
    key: "surAnnulation",
    value: function surAnnulation() {
      if ((0, _utilitaires.estDefini)(this.props.surAnnulation)) {
        this.props.surAnnulation();
      }

      this.reinitialiser();
    } // Évènements liés à Form

  }, {
    key: "surChoixTypeDocument",
    value: function surChoixTypeDocument(event) {
      var desactiver = !(0, _utilitaires.nestPasNulOuVide)(event.target.value);

      if (desactiver === true) {
        this.surDesactiverConfimation();
      }

      var etiquette = event.target[event.target.selectedIndex].text;
      this.setState({
        etiquetteDocument: etiquette,
        typeDocument: event.target.value,
        fichier: '',
        desactiverRecherche: desactiver
      });
    }
  }, {
    key: "envoyer",
    value: function envoyer(event) {
      var infos = {
        typeDocument: this.state.typeDocument,
        fichier: event.target.files[0]
      };
      this.setState({
        erreur: null,
        erreur2: null,
        fichier: event.target.files[0].name
      });

      if (!this.validerEnvoi(infos)) {
        return;
      }

      var formData = new FormData();
      formData.append("Fichier", event.target.files[0], event.target.files[0].name);
      formData.append("NomFichier", event.target.files[0].name);
      formData.append("TypeDocument", this.state.typeDocument);
      formData.append("EtiquetteDocument", this.state.etiquetteDocument);
      var informations = {
        formData: formData,
        etiquetteDocument: this.state.etiquetteDocument,
        typeDocument: this.state.typeDocument,
        fichier: event.target.files[0]
      };
      this.surReceptionInformations(informations);
    }
  }, {
    key: "validerEnvoi",
    value: function validerEnvoi(informations) {
      var fichier = informations.fichier;

      if (!(0, _utilitaires.estDefini)(fichier)) {
        this.surDesactiverConfimation();
        return false;
      } else if (fichier.size > this.state.maxTaille) {
        var taille = this.state.maxTaille / (kilo_octet * kilo_octet);
        var uneErreur = "La taille du fichier ne doit pas excéder " + taille + " Mo.";
        this.setState({
          erreur: uneErreur,
          erreur2: null
        });
        this.surErreurFichier({
          erreur: uneErreur
        });
        return false;
      } else {
        var longueur = fichier.name.length - 4;
        var extentionFichier = '';

        if (longueur > 3) {
          extentionFichier = fichier.name.toLowerCase().substring(longueur);
        }

        var trouve = this.state.extentions.find(function (element) {
          return element.toLowerCase() === extentionFichier;
        });

        if (!(0, _utilitaires.estDefini)(trouve)) {
          var _uneErreur = "Le type ('" + extentionFichier + "') du fichier sélectionné n'est pas accepté.";

          var uneErreur2 = "Uniquement les fichiers ('" + this.props.typeDocumentsExtentions + "') peuvent être attachés à une demande.";
          this.setState({
            erreur: _uneErreur,
            erreur2: uneErreur2
          });
          this.surErreurFichier({
            erreur: _uneErreur
          });
          return false;
        }
      }

      if ((0, _utilitaires.estDefini)(this.props.surValidation)) {
        var retourValidation = this.props.surValidation(informations);

        if (retourValidation !== true) {
          var _uneErreur2 = "L'antivirus a détecté un problème dans votre fichier.\n Veuillez corriger et/ou télécharger un autre fichier.";

          if (retourValidation !== false) {
            _uneErreur2 = retourValidation;
          }

          this.setState({
            erreur: _uneErreur2,
            erreur2: null
          });
          return false;
        }
      }

      return true;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_MfaDialogue.MfaDialogue, {
        titre: this.props.titre,
        estVisible: this.props.estVisible,
        surSortie: this.surSortie,
        surAnnulation: this.surAnnulation,
        afficherBoutonAnnulerExtremeGauche: true,
        desactiverBoutonSortir: this.state.desactiverBoutonSortir,
        messageboutonAnnulation: this.props.messageboutonAnnulation,
        messageboutonSortie: this.props.messageboutonSortie
      }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form, null, (0, _utilitaires.estDefini)(this.props.typeDocuments) && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Group, {
        controlId: "TypeDocument"
      }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Label, {
        className: "mfa-section-titre-cache"
      }, this.props.titreTypeDocument), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Control, {
        className: "mfa-section-titre-cache",
        as: "select",
        value: this.state.typeDocument,
        onChange: function onChange(event) {
          return _this2.surChoixTypeDocument(event);
        }
      }, this.props.typeDocuments.map(function (e, key) {
        return /*#__PURE__*/_react.default.createElement("option", {
          key: key,
          value: e.valeur
        }, e.etiquette);
      }))), /*#__PURE__*/_react.default.createElement("br", null), " ", /*#__PURE__*/_react.default.createElement("br", null)), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Group, {
        controlId: "Telechargement"
      }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("input", {
        type: "file",
        className: "mfa-telechargement-input",
        id: "bouton-fichier",
        disabled: this.state.desactiverRecherche,
        onChange: function onChange(event) {
          return _this2.envoyer(event);
        },
        accept: (0, _utilitaires.nestPasNulOuVide)(this.props.typeDocumentsExtentions) ? this.props.typeDocumentsExtentions : '*.*'
      }), /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("label", {
        htmlFor: "bouton-fichier"
      }, /*#__PURE__*/_react.default.createElement(_core.Button, {
        style: {
          textTransform: 'none'
        },
        color: "primary",
        variant: "outlined",
        disabled: !this.state.desactiverRecherche
      }, "Rechercher...")), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Label, {
        className: "mfa-section-titre-cache desactiveChamp"
      }, this.state.fichier))), /*#__PURE__*/_react.default.createElement("br", null), " ", /*#__PURE__*/_react.default.createElement("br", null), (0, _utilitaires.nestPasNulOuVide)(this.state.erreur) && /*#__PURE__*/_react.default.createElement("div", {
        className: "alert alert-danger",
        role: "alert"
      }, this.state.erreur, (0, _utilitaires.nestPasNulOuVide)(this.state.erreur2) && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("br", null), this.state.erreur2))))));
    }
  }, {
    key: "obtenirPropsFiltrees",
    value: function obtenirPropsFiltrees() {
      return (0, _utilitaires.filtrerProprietesObjet)(this.props, ['estObligatoire', 'etiquette']);
    }
  }]);

  return MfaTelechargement;
}(_react.Component);

exports.MfaTelechargement = MfaTelechargement;

_defineProperty(MfaTelechargement, "defaultProps", {
  titre: "Ajouter un document",
  messageboutonSortie: "Ajouter"
});

_defineProperty(MfaTelechargement, "propTypes", {
  tailleMaximale: _propTypes.default.number,
  surValidation: _propTypes.default.func.isRequired
});